import { checkTest, continueTest, informTest, startTest } from '../../api/test/index';
import actions from '../actions/index';

// Мережева помилка (timeout, обрив) не має error.response: старий код падав
// TypeError усередині catch, стан не оновлювався і студент застрягав на
// заблокованій кнопці без жодного повідомлення.
const extractTestError = (error) =>
  error?.response?.data?.info?.message
  || 'Не вдалося зв\'язатися з сервером. Перевірте інтернет і спробуйте ще раз.';

export function getTestThunk(data) {
  return (dispatch) => {
    dispatch(actions.test.startFetching());
    startTest(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.test.getTest(res.data.data));
          dispatch(actions.test.getTestAnswers(res.data.data.homework_task_answers));
          dispatch(actions.test.getTestDefinitions(res.data.data.homework_task_definitions));
          dispatch(actions.test.getTestType(res.data.data.homework_block_type));
        }
      })
      .catch(error => {
        dispatch(actions.test.getTestError(extractTestError(error)));
      })
      .finally(() => dispatch(actions.test.stopFetching()));
  };
}

export function continueTestThunk(data) {
  return (dispatch) => {
    dispatch(actions.test.startFetchingBtn());
    continueTest(data)
      .then(res => {
        if (res.data.info.status) {
          if(res.data.data.is_finished) {
            dispatch(actions.test.finishedTest(res.data.data));
          } else {
            dispatch(actions.test.getTest(res.data.data));
            dispatch(actions.test.getTestAnswers(res.data.data.homework_task_answers));
            dispatch(actions.test.getTestDefinitions(res.data.data.homework_task_definitions));
            dispatch(actions.test.getTestType(res.data.data.homework_block_type));
          }
        }
      })
      .catch(error => {
        dispatch(actions.test.getTestError(extractTestError(error)));
      })
      .finally(() => dispatch(actions.test.stopFetchingBtn()));
  };
}

export function checkTestThunk(data) {
  return (dispatch) => {
    dispatch(actions.test.startFetchingBtn());
    checkTest(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.test.checkTest(res.data.data));
        }
      })
      .catch(error => {
        dispatch(actions.test.getTestError(extractTestError(error)));
      })
      .finally(() => dispatch(actions.test.stopFetchingBtn()));
  };
}

export function informTestThunk(data) {
  return (dispatch) => {
    informTest(data)
      .then(res => {
        if (res.data.info.status) {
          dispatch(actions.test.informTest(res.data.data.text));
        }
      })
      .catch(error => {
        dispatch(actions.test.informTestError(extractTestError(error)));
      });
  };
}